import ErrorBackground from './ErrorBackground.png'
import DragAndDropIcon from '../icons/dragon-drop.svg'
import UpArrow from '../icons/newUpArrow.svg'
import BgRectangle from './bgRectangle.png'
import BgRectangleLight from './bgRectangleLight.png'
import MenuSwitchTooltipImageDark from './menuSwitchTooltipImageDark.png'
import MenuSwitchTooltipImageLight from './menuSwitchTooltipImageLight.png'
 
export default{
    ErrorBackground,
    DragAndDropIcon,
    UpArrow,
    BgRectangle,
    BgRectangleLight,
    MenuSwitchTooltipImageDark,
    MenuSwitchTooltipImageLight
}